// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1756":"cb549fa0","4660":"bdadde0a","6422":"17fabdd3","8777":"fe58350d"}[chunkId] + ".chunk.css";
};